import type { EntityConfig } from '../types'

export const invoiceEntity: EntityConfig = {
  id: 'invoice',
  displayName: 'Invoice',
  status: {
    filters: [
      { value: 'all', label: 'All' },
      { value: 'draft', label: 'Draft' },
      { value: 'sent', label: 'Sent' },
      { value: 'paid', label: 'Paid' },
      { value: 'overdue', label: 'Overdue' },
      { value: 'cancelled', label: 'Cancelled' },
    ],
    options: [
      { value: 'draft', label: 'Draft', color: 'neutral' },
      { value: 'sent', label: 'Sent', color: 'pending' },
      { value: 'paid', label: 'Paid', color: 'success' },
      { value: 'overdue', label: 'Overdue', color: 'warning' },
      { value: 'cancelled', label: 'Cancelled', color: 'error' },
    ],
    mappings: {
      all: ['draft', 'sent', 'paid', 'overdue', 'cancelled'],
      draft: ['draft'],
      sent: ['sent'],
      paid: ['paid'],
      overdue: ['overdue'],
      cancelled: ['cancelled'],
    }
  },
  queryFields: {
    status: { type: 'status_array', urlKey: 'status' },
    dateRange: { type: 'date_range', urlKey: 'date' },
    createdDate: { type: 'date_range', urlKey: 'createdDate' },
    dueDate: { type: 'date_range', urlKey: 'dueDate' },
    finalizationDate: { type: 'date_range', urlKey: 'finalizationDate' },
    amount: { type: 'amount', urlKey: 'amount' },
    frequency: { type: 'string_array', urlKey: 'frequency' },
    customerName: { type: 'search', urlKey: 'customerName' },
    invoiceNumber: { type: 'search', urlKey: 'invoiceNumber' },
    search: { type: 'search', urlKey: '$s' }
  },
  uiFilterFields: [
    'search',
    'status',
    'createdDate',
    'dueDate',
    'finalizationDate',
    'amount',
  ]
}
